export var errorFlowType = {
  APP_LOAD: 'app-load',
  INTERACTION: 'interaction'
};